export default "__VITE_ASSET__BrYrRL3h__"